/*!
 * Codpeller (frontend)
 *
 * @author    DevTeam <info@kinvasoft.com>
 * @copyright Copyright (c) 2013-present <info@kinvasoft.com>. All rights reserved
 * @license   Proprietary
 */

(function (d) {
  // Language detector
  const getFirstBrowserLanguage = function () {
    var nav = window.navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  // Change language
  const changeLanguage = function (language) {
    const supportedLanguages = ['ru', 'en', 'kz'];

    if (supportedLanguages.indexOf(language) === -1) {
      // English default
      language = 'en';
    }

    let currentUrl = new URL(window.location.href);
    let splittedPath = currentUrl.pathname.split('/');

    if (supportedLanguages.indexOf(splittedPath[1]) !== -1) {
      splittedPath[1] = language;
    } else {
      splittedPath[1] = language;
    }

    window.location.href = currentUrl.origin + splittedPath.join('/');
  };
  const isAutoChangeLanguageRequired = function () {
    return sessionStorage.getItem('lnguage-has-been-auto-switch') !== 'true';
  };
  const autoSwitchLanguage = function (language) {
    if (isAutoChangeLanguageRequired()) {
      changeLanguage(language);
      sessionStorage.setItem('lnguage-has-been-auto-switch', 'true');
    }
  };
  // Language selector
  const langSelectors = d.querySelectorAll('#language-mobile, #language-desktop');
  Array.from(langSelectors).forEach((langSelector) => {
    langSelector.addEventListener('change', (event) => {
      const language = event.target.value;
      changeLanguage(language);
    });
  });
  // Auto-switch language
  autoSwitchLanguage(getFirstBrowserLanguage());
  // Tabs
  const tabs = d.querySelectorAll('[role="tablist"] > [role="tab"]');
  const tabPanels = d.querySelectorAll('[role="tabpanel"]');
  Array.from(tabs).forEach((tab) => {
    tab.addEventListener('click', (event) => {
      const tabPanelId = tab.getAttribute('aria-controls');
      // unselect all
      Array.from(tabs).forEach((element) => {
        element.classList.remove('border-indigo-600', 'text-indigo-600');
        element.classList.remove('border-transparent', 'text-gray-700', 'hover:text-gray-800', 'hover:border-gray-300');
      });
      // mark selected
      tab.classList.add('border-indigo-600', 'text-indigo-600');
      // hide panels
      Array.from(tabPanels).forEach((element) => {
        element.style.display = 'none';
      });
      // show selected
      d.getElementById(tabPanelId).style.display = '';
    });
  });

  // Menu (desktop)
  (function (d) {
    const isTouch = matchMedia('(hover: none)').matches;
    const desktopItems = d.querySelectorAll('header nav .relative > button');
    const desktopItemClasses = {
      entering: {
        classes: ['transition', 'ease-out', 'duration-200'],
        from: ['opacity-0', 'translate-y-1'],
        to: ['opacity-100', 'translate-y-0'],
      },
      leaving: {
        classes: ['transition', 'ease-in', 'duration-150'],
        from: ['opacity-100', 'translate-y-0'],
        to: ['opacity-0', 'translate-y-1'],
      },
    };

    let activeDropdown = null;
    let hideTimeout = null;

    desktopItems.forEach((item) => {
      const dropdown = item.parentNode.querySelector('div.absolute');

      const showDropdown = () => {
        clearTimeout(hideTimeout);
        if (activeDropdown && activeDropdown !== dropdown) {
          hideDropdown(activeDropdown);
        }
        dropdown.classList.remove(...desktopItemClasses.leaving.classes);
        dropdown.classList.remove(...desktopItemClasses.leaving.to);
        dropdown.classList.add(...desktopItemClasses.entering.classes);
        dropdown.classList.remove(...desktopItemClasses.entering.from);
        dropdown.classList.add(...desktopItemClasses.entering.to);
        item.setAttribute('aria-expanded', 'true');
        activeDropdown = dropdown;
      };

      const hideDropdown = (dropdownEl) => {
        dropdownEl.classList.add(...desktopItemClasses.leaving.classes);
        dropdownEl.classList.remove(...desktopItemClasses.leaving.from);
        dropdownEl.classList.add(...desktopItemClasses.leaving.to);
        const relatedButton = dropdownEl.parentNode.querySelector('button');
        if (relatedButton) {
          relatedButton.setAttribute('aria-expanded', 'false');
        }
        if (activeDropdown === dropdownEl) activeDropdown = null;
      };

      if (isTouch) {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.getAttribute('aria-expanded') === 'true') {
            hideDropdown(dropdown);
          } else {
            showDropdown();
          }
        });
      } else {
        item.addEventListener('mouseenter', showDropdown);
        item.addEventListener('mouseleave', () => {
          hideTimeout = setTimeout(() => {
            hideDropdown(dropdown);
          }, 250);
        });

        dropdown.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout);
        });

        dropdown.addEventListener('mouseleave', () => {
          hideTimeout = setTimeout(() => {
            hideDropdown(dropdown);
          }, 250);
        });
      }
    });
  })(document);

 // Меню (mobile) — оборачиваем в проверку, чтобы не пытаться вешать события на несуществующие элементы
  const mobileOpenButton = d.querySelector('header > .relative > .mx-auto div > button');
  const mobileCloseButton = d.querySelector('header > .relative > .absolute div > button');
  const mobileDropdown = d.querySelector('header > .relative > .absolute');
  const mobileMenuClasses = {
    entering: {
      classes: ['transition', 'ease-out', 'duration-200'],
      from: ['opacity-0', 'scale-95'],
      to: ['opacity-100', 'scale-100'],
    },
    leaving: {
      classes: ['transition', 'ease-in', 'duration-150'],
      from: ['opacity-100', 'scale-100'],
      to: ['opacity-0', 'scale-95'],
    },
  };

  if (mobileOpenButton && mobileCloseButton && mobileDropdown) {
    mobileDropdown.addEventListener('animationstart', () => {
      if (mobileOpenButton.getAttribute('aria-expanded') === 'true') {
        mobileDropdown.style.display = '';
      }
    });

    mobileDropdown.addEventListener('animationend', () => {
      if (mobileOpenButton.getAttribute('aria-expanded') === 'false') {
        mobileDropdown.style.display = 'none';
      }
    });

    mobileOpenButton.addEventListener('click', (event) => {
      mobileOpenButton.setAttribute('aria-expanded', 'true');
      mobileDropdown.classList.add(...mobileMenuClasses.entering.classes);
      mobileDropdown.classList.remove(...mobileMenuClasses.entering.from);
      mobileDropdown.classList.add(...mobileMenuClasses.entering.to);
      mobileDropdown.style.visibility = 'visible';
    });

    mobileCloseButton.addEventListener('click', (event) => {
      mobileOpenButton.setAttribute('aria-expanded', 'false');
      mobileDropdown.classList.add(...mobileMenuClasses.leaving.classes);
      mobileDropdown.classList.remove(...mobileMenuClasses.leaving.from);
      mobileDropdown.classList.add(...mobileMenuClasses.leaving.to);
      mobileDropdown.style.visibility = 'hidden';
    });
  }

  // 🔽 Добавляем эффект печатания слов в элемент с id="typed-text"
  const words = ["приёма онлайн-оплат", "фискализации чеков", "роста продаж", "удобной навигации", "подключения онлайн-кассы"];
  const typedText = d.getElementById("typed-text");
  if (typedText) {
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function type() {
      const currentWord = words[wordIndex];
      const visibleText = currentWord.substring(0, charIndex);
      typedText.textContent = visibleText;

      if (!isDeleting && charIndex < currentWord.length) {
        charIndex++;
        setTimeout(type, 120);
      } else if (isDeleting && charIndex > 0) {
        charIndex--;
        setTimeout(type, 60);
      } else {
        isDeleting = !isDeleting;
        if (!isDeleting) wordIndex = (wordIndex + 1) % words.length;
        setTimeout(type, 1000);
      }
    }

    type();
  }

// Парсинг цен
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const htmlLang = document.documentElement.lang || "ru";
    const isRussian = htmlLang.startsWith("ru");

    function extractIntegerPrice(raw) {
      const cleaned = raw.replace(/\s+/g, "").replace(/[^0-9.,]/g, "");
      const noFraction = cleaned.replace(/\.(?:00|0)$/, "");
      const num = parseInt(noFraction, 10);
      return isNaN(num) ? 0 : num;
    }

    function formatWithSpaces(n) {
      return n.toLocaleString("ru-RU");
    }

    async function updatePrices(containerElement) {
      const productUrl = containerElement.getAttribute("data-product-url");
      if (!productUrl) return;

      try {
        // --- KZT ---
        const respKzt = await fetch(productUrl);
        if (!respKzt.ok) throw new Error(`Ошибка HTTP ${respKzt.status}`);
        const htmlKzt = await respKzt.text();
        const docKzt = new DOMParser().parseFromString(htmlKzt, "text/html");
        let priceElemKzt = docKzt.querySelector("li.product-price-base span.price.product-price");
        if (!priceElemKzt) {
          priceElemKzt = docKzt.querySelector(
            "#content > div > div > div.product-details.product-details-info > " +
            "div.product-details-info > div.product-price.widget-fingerprint-product-price > " +
            "ul > li.product-price-base > span.price.product-price"
          );
        }
        if (!priceElemKzt) throw new Error("KZT-селектор не сработал");
        const rawKzt = priceElemKzt.textContent.trim();
        const numKzt = extractIntegerPrice(rawKzt);
        const strKzt = formatWithSpaces(numKzt);

        // --- USD ---
        const usdUrl = productUrl.includes("?")
          ? productUrl.replace(/\?.*$/, "?currency=USD")
          : (productUrl + "?currency=USD");
        const respUsd = await fetch(usdUrl);
        if (!respUsd.ok) throw new Error(`Ошибка HTTP ${respUsd.status}`);
        const htmlUsd = await respUsd.text();
        const docUsd = new DOMParser().parseFromString(htmlUsd, "text/html");
        let priceElemUsd = docUsd.querySelector("li.product-price-base span.price.product-price");
        if (!priceElemUsd) {
          priceElemUsd = docUsd.querySelector(
            "#content > div > div > div.product-details.product-details-info > " +
            "div.product-details-info > div.product-price.widget-fingerprint-product-price > " +
            "ul > li.product-price-base > span.price.product-price"
          );
        }
        if (!priceElemUsd) throw new Error("USD-селектор не сработал");
        const rawUsd = priceElemUsd.textContent.trim();
        const numUsd = extractIntegerPrice(rawUsd);
        const strUsd = formatWithSpaces(numUsd);

        containerElement.classList.remove("skeleton");
        containerElement.classList.add("loaded");

        if (isRussian) {
          containerElement.innerHTML = `
            ${strKzt}&nbsp;₸ в&nbsp;год 
            <span class="block mt-2 text-sm text-gray-500">(~$${strUsd}&nbsp;в&nbsp;год)</span>
          `;
        } else {
          containerElement.innerHTML = `
            ${strKzt}&nbsp;₸ per&nbsp;year
            <span class="block mt-2 text-sm text-gray-500">(~$${strUsd}&nbsp;per&nbsp;year)</span>
          `;
        }
      }
      catch (err) {
        console.error("Ошибка при загрузке цен:", err);
        containerElement.classList.remove("skeleton");
        containerElement.classList.add("loaded");
        containerElement.textContent = isRussian ? "Ошибка загрузки ₸" : "Price load error";
      }
    }

    // Ищем все <p class="kzt-price"> и обновляем их
    const allKztPlaceholders = document.querySelectorAll("p.kzt-price");
    allKztPlaceholders.forEach(el => {
      updatePrices(el);
    });
  });
})();




})(document);

